import { render, staticRenderFns } from "./SiteAppsPlugin.vue?vue&type=template&id=6715cc44&scoped=true&"
import script from "./SiteAppsPlugin.vue?vue&type=script&lang=js&"
export * from "./SiteAppsPlugin.vue?vue&type=script&lang=js&"
import style0 from "./SiteAppsPlugin.vue?vue&type=style&index=0&id=6715cc44&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6715cc44",
  null
  
)

export default component.exports